import React, { useEffect, useState } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { Box, LinearProgress, Snackbar, MenuItem, Alert } from '@mui/material'
import { getSubscription, setSubscriptionEnd } from "../../service/payApi"
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined'

interface Props {
  onCloseMenu: () => void
}
export default function RestartSubscription({ onCloseMenu }: Props) {
  const queryClient = useQueryClient()
  const [busy, setBusy] = useState(false)
  const [successSnack, setSuccessSnack] = useState(false)
  const [errorSnack, setErrorSnack] = useState(false)

  const { data: sub } = useQuery({
    queryKey: ['getSubscription'], queryFn: getSubscription,
    enabled: queryClient.getQueryData(['getSubscription']) === undefined,
  })

  async function onClick() {
    setBusy(true)
    const res = await setSubscriptionEnd(false)
    if (res instanceof Error)
      setErrorSnack(true)
    else {
      setSuccessSnack(true)
      await queryClient.invalidateQueries({ queryKey: ['getSubscription'] })
      onCloseMenu()
    }
    setBusy(false)
  }

  if (!sub?.subscription?.cancel_at)
    return null

  return (
    <>

      <MenuItem onClick={onClick}>
        <RestartAltOutlinedIcon sx={{ color: 'gray', marginRight: "15px" }} />
        Restart Subscription
      </MenuItem>

      {busy && <LinearProgress />}

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={successSnack} autoHideDuration={3000}
        onClose={() => setSuccessSnack(false)}
      >
        <Alert variant="filled" severity="success" >
          Subscription Restarted
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={errorSnack} autoHideDuration={3000}
        onClose={() => setErrorSnack(false)}
      >
        <Alert variant="filled" severity="error" >
          Subscription Restarted Failed. Please Try Again, or contact support@finmate.ai
        </Alert>
      </Snackbar>
    </>
  )
}
